export const DEVICE_ID_KEY = 'device-id'
export const SESSION_ID_KEY = 'session-id'
export const SESSION_TTL_SECONDS = 1800
export const EXPERIMENT_MEMBER_COOKIE_NAME = 'experiment_member_id'
